module.exports = "<symbol id=\"tt-icon-star--full\" viewBox=\"0 0 24 24\"><path d=\"M12 18.66l-7.44 4.35 1.98-8.16L0 9.36l8.62-.7L12 .99l3.38 7.67 8.62.7-6.54 5.49 1.98 8.16L12 18.66z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/search-page/star--full.svg
// module id = 440
// module chunks = 11